// The University of Rhode Island's undergraduate majors (#2840). Read on
// 2026-10-01 from the official 2026-27 Online Catalog's Programs List
// (web.uri.edu/catalog, a Kuali catalog; each program's college comes from
// the catalog's own record for it, read through the catalog's public API
// at uri.kuali.co for catalog 2026-2027). Every program titled with a
// bachelor's degree (BA, BS, BSBA, BFA, BIS, BLA, BM) is kept, under its
// college, with the catalog's degree abbreviation; minors, certificates,
// graduate programs and the "RN to BS" degree-completion programs for
// registered nurses are left out. The catalog lists both "Bachelor of
// Interdisciplinary Studies - BIS" (shown here as Interdisciplinary
// Studies) and "Learner Designed - BIS". College names are the catalog's
// college filters written out in full (for example "Environment and Life
// Sciences" as College of the Environment and Life Sciences). The KB's
// majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-rhode-island",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in URI's official 2026-27 Online Catalog, grouped by the college that offers it, with the degree it leads to. Minors, certificates, graduate programs and the RN to BS completion programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "URI 2026-27 Online Catalog, Programs List",
                "url": "https://web.uri.edu/catalog/#/programs"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BIS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry and Forensic Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Classical Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Criminology and Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Arts and Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Film",
                    "degree": "BFA"
                },
                {
                    "name": "Film Media",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Gender and Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Global Language and Area Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Learner Designed",
                    "degree": "BIS",
                    "note": "A Bachelor of Interdisciplinary Studies you design."
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BM"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics & Physical Oceanography",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Professional and Public Writing",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Sports Media and Communication",
                    "degree": "BA"
                },
                {
                    "name": "Strategic Communication",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "URI 2026-27 Online Catalog, Programs List",
                "url": "https://web.uri.edu/catalog/#/programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Analytics and Artificial Intelligence",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Studies",
                    "degree": "BA"
                },
                {
                    "name": "Fashion Business",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "General Business Administration",
                    "degree": "BSBA"
                },
                {
                    "name": "Global Business Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Innovation and Entrepreneurship",
                    "degree": "BSBA"
                },
                {
                    "name": "Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Textile Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Textiles, Fashion Merchandising and Design",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "URI 2026-27 Online Catalog, Programs List",
                "url": "https://web.uri.edu/catalog/#/programs"
            },
            "majors": [
                {
                    "name": "Early Childhood Care and Education",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Education",
                    "degree": "BS"
                },
                {
                    "name": "Health and Physical Education",
                    "degree": "BS"
                },
                {
                    "name": "Learning and Education in Action",
                    "degree": "BA"
                },
                {
                    "name": "Non Profit Administration",
                    "degree": "BS"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BA"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BS"
                },
                {
                    "name": "World Language Education",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "URI 2026-27 Online Catalog, Programs List",
                "url": "https://web.uri.edu/catalog/#/programs"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Ocean Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of the Environment and Life Sciences",
            "source": {
                "label": "URI 2026-27 Online Catalog, Programs List",
                "url": "https://web.uri.edu/catalog/#/programs"
            },
            "majors": [
                {
                    "name": "Animal and Veterinary Science",
                    "degree": "BS"
                },
                {
                    "name": "Aquaculture and Fisheries Science",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Cell and Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Environmental and Natural Resource Economics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science and Management",
                    "degree": "BS"
                },
                {
                    "name": "Geology and Geological Oceanography",
                    "degree": "BS"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                },
                {
                    "name": "Marine Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Marine Affairs",
                    "degree": "BS"
                },
                {
                    "name": "Marine Biology",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "BS"
                },
                {
                    "name": "Molecular Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Plant Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Sustainable Food Systems",
                    "degree": "BA"
                },
                {
                    "name": "Sustainable Food Systems",
                    "degree": "BS"
                },
                {
                    "name": "Wildlife and Conservation Biology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Health Sciences",
            "source": {
                "label": "URI 2026-27 Online Catalog, Programs List",
                "url": "https://web.uri.edu/catalog/#/programs"
            },
            "majors": [
                {
                    "name": "Clinical Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Communicative Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "URI 2026-27 Online Catalog, Programs List",
                "url": "https://web.uri.edu/catalog/#/programs"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Pharmacy",
            "source": {
                "label": "URI 2026-27 Online Catalog, Programs List",
                "url": "https://web.uri.edu/catalog/#/programs"
            },
            "majors": [
                {
                    "name": "Biomedical and Pharmaceutical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Medicinal Neuroscience",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
